<template>
  <div id="contents">
    <div class="inner ">
      <h3 class="main-title">오시는 길</h3>
      <ul class="tab-wrap">
        <li><a href="/contact-us" class="tab-btn">상담 신청</a></li>
        <li><a href="/map" class="tab-btn active">오시는 길</a></li>
      </ul>
    </div>
    <article class="maps-wrap">
      <div class="inner small">
        <div class="maps">
          <div style="height: 590px;"><a href="https://map.kakao.com/?urlX=474183.0&amp;urlY=1105266.0&amp;itemId=1061849593&amp;q=%EC%95%A0%EB%93%9C%EB%A7%A4%EC%8A%A4&amp;srcid=1061849593&amp;map_type=TYPE_MAP&amp;from=roughmap" target="_blank"><img class="map" src="http://t1.daumcdn.net/roughmap/imgmap/e73c1a16b852162300ac1fb2965eaaae1b6bc1964c9428364916f8cf5156af4d" width="1162px" height="588px" ></a>
          </div>
        </div>
        <div class="maps-grid-box">
          <h4 class="gird-title">CONTACT INFO</h4>
          <ul class="maps-flex-box">
            <li>TEL<br/>02-2067-1213</li>
            <li>Address<br/>서울특별시 금천구 가산디지털1로 142 스카이밸리1차 5층 516호</li>
            <li>Hours<br/>업무시간: 오전 9:30~ 오후 6:30</li>
          </ul>
        </div>
      </div>
    </article>
  </div>
</template>
<script>

export default {
  name: 'page-map',
  components: {

  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>